import _ from 'underscore';
import DeletionSource from "models/audioEditor/DeletionSource";


const CLASSNAME = "TextSearchDeletionSource";
const TextSearchDeletionSource =  DeletionSource.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        DeletionSource.apply(this, [attributes, options]);
    },

    getConstructor : function(){
        return TextSearchDeletionSource;
    },

    clone: function(){
        return new TextSearchDeletionSource(this.toJSON());
    },

    getKeywordSearch: function(){
        return this.get("keywordSearch");
    },

    setKeywordSearch: function(keywordSearch) {
        this.set("keywordSearch", keywordSearch);
    },

    afterInstanceCreatedFromConstructorForCloning : function(createdClonedInstance){

    },

    getSerializedData : function(){
        const serializedData = DeletionSource.prototype.getSerializedData.call(this);
        serializedData.classname =  TextSearchDeletionSource.CLASSNAME;
        serializedData.keywordSearch = this.getKeywordSearch();
        return serializedData;
    },

    restoreFromSerializedData: function(serializedData){
        DeletionSource.prototype.restoreFromSerializedData.call(this, serializedData);
        this.setKeywordSearch(serializedData.keywordSearch);
        return this;
    },

    afterAllInstancesCreatedFromSerializedData : function(serializedData){
        DeletionSource.prototype.afterAllInstancesCreatedFromSerializedData.call(this, serializedData);
    },


    cloneJSON: function(){
        const objJson = DeletionSource.prototype.cloneJSON.call(this);
        objJson.keywordSearch = this.getKeywordSearch();
        objJson.classname = TextSearchDeletionSource.CLASSNAME;
        return objJson;
    },

});

TextSearchDeletionSource.CLASSNAME =  CLASSNAME;
export default TextSearchDeletionSource; 